import { useTranslations } from "@zapier/i18n";
import { Alert } from "@zapier/design-system";

interface Props {
  assetTitle: string | null;
  parentFolderName: string;
  sourceFolderCount?: number;
}

export function FolderSharingAlert({
  assetTitle,
  parentFolderName,
  sourceFolderCount,
}: Props) {
  const t = useTranslations("folder-sharing-alert");
  const hasAssetTitle = Boolean(assetTitle?.trim());
  const isMultiFolderSelection = (sourceFolderCount ?? 0) > 1;

  return (
    <div>
      <Alert
        variant="default"
        title={
          isMultiFolderSelection
            ? t("alerts.sharing-warning-title-plural")
            : t("alerts.sharing-warning-title")
        }
        status="info"
      >
        {hasAssetTitle
          ? t.rich("alerts.sharing-warning-description", {
              assetTitle: assetTitle || "",
              parentFolderName: parentFolderName || "",
              bold1: (chunks) => <b>{chunks}</b>,
              bold2: (chunks) => <b>{chunks}</b>,
              bold3: (chunks) => <b>{chunks}</b>,
              bold4: (chunks) => <b>{chunks}</b>,
            })
          : t.rich("alerts.sharing-warning-description-generic-plural", {
              parentFolderName: parentFolderName || "",
              bold1: (chunks) => <b>{chunks}</b>,
              bold2: (chunks) => <b>{chunks}</b>,
            })}
      </Alert>
    </div>
  );
}
